const EXTRACT_DATA_REGEX = /<\!--(?:.|[\n\r])*Memability-notes:[\n\r\s]*([{\[][^>]*)-->/m;

export function extractImportFileContent(contentStr) {
   const matches = contentStr && contentStr.match(EXTRACT_DATA_REGEX);
   let result: any = null;

   if (matches && matches.length > 1) {
      result = matches[1];
      result = result.replace(/&gt;/g, ">");
      result = JSON.parse(result);
   }

   return result.length ? result : [result];
}
